export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDSrPxiERy_4EG8wjS8twva4LLeh0kcDPg",
    authDomain: "premier-dev-2534c.firebaseapp.com",
    projectId: "premier-dev-2534c",
    storageBucket: "premier-dev-2534c.firebasestorage.app",
    messagingSenderId: "739809442220",
    appId: "1:739809442220:web:2500234df11e4bfb34a209"
  },
  openaiApiKey: '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',
  sendgrid: {
    apiKey: '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'
  },
  // Jira OAuth Configuration
  jiraAuthUrl: 'https://auth.atlassian.com/authorize',
  jiraTokenUrl: 'https://auth.atlassian.com/oauth/token',
  jiraApiUrl: 'https://api.atlassian.com',
  jiraClientId: '38ma0r8I8BErvunu0o6SDzHNC8nZpCrL',
  jiraClientSecret: 'ATOAnoxbAhx3FlYPkBURiwsOsMhFx6LHkdX4vldwv9yJZD_16AUFY5i3sMhS75bmboD88FCC5D5A',
  jiraRedirectUri: 'https://devpremiergr.netlify.app/auth/callback',
  jiraProjectKey: 'PGW',
  jira: {
    baseUrl: 'https://sentralgroup.atlassian.net/', // Replace with your Jira domain
    email: '', // Will be set through admin settings
    apiToken: '', // Will be set through admin settings
    projectKey: 'PGW'
  }
}; 